<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="0"
      :BackPath="'/A01'"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container
      :Type="false"
      :ImgUrl="'A0101.png'"
      :ImgUrls="'A0101.png'"
      :Container="Container"
      style="z-index: -6"
    ></Container>
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Container from "@/components/Container4.vue";
export default {
  name: "A0101",
  data() {
    return {
      Bignav: false,
      Container: {
        subtitle: "",
        videosrc: "A01.mp4",
        title: "提升患者體驗",
        text: "癌症不會等待。在癌症治療中，每一天都至關重要。即使是幾週的延誤也可能改變治療結果。提升患者體驗，意味著幫助人們以更輕鬆、更少焦慮、懷抱希望的心情完成治療歷程。\n",
        listtitle: "簡化的照護歷程",
        list: [
          {
            body:  "減少就診次數"
          },
          {
            body:  "縮短治療時間"
          },
          {
            body:  "更明確的溝通，協助患者掌握預期狀況"
          },
          {
            body:  "營造建立信任並延續希望的環境"
          },

        ],
        endtitle: "全方位的工作流程，實現以人為本的照護"
      }
    };
  },
  components: {
    Back,
    Container,
    Bigmenu
  },
  methods: {
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;

}
</style>
